export enum CargaDescargaTypes {
  'LOAD_REQUEST_CARGA_DESCARGA' = '@cargaDescarga/LOAD_REQUEST_CARGA_DESCARGA',
  'LOAD_SUCCESS_CARGA_DESCARGA' = '@cargaDescarga/LOAD_SUCCESS_CARGA_DESCARGA',
  'LOAD_FAILURE_CARGA_DESCARGA' = '@cargaDescarga/LOAD_FAILURE_CARGA_DESCARGA',

  'CLEAN_CARGA_DESCARGA' = '@cargaDescarga/CLEAN_CARGA_DESCARGA',
}

export interface CargaDescargaTotal {
  descarga: number;
  centroDistribuicao: string;
  descargaConcluida: number;
  cargas: number;
  codemp: number;
  cargasConcluida: number;
  cargaPerc: number;
  descargaPerc: number;
  pesoCargas: number;
  pesoDescargas: number;
}

export interface CargaDescarga {
  descarga: number;
  centroDistribuicao: string;
  descargaConcluida: number;
  cargas: number;
  codemp: number;
  cargasConcluida: number;
  descargaPerc: number;
  cargaPerc: number;
  pesoCarga: number;
  pesoPendenteCarga: number;
  pesoDescarga: number;
  pesoPendenteDescarga: number;
}

export interface CargaDescargaState {
  readonly data: CargaDescarga[];
  readonly dataTotal: CargaDescargaTotal;
  readonly error: boolean;
  readonly loading: boolean;
}
